'use client'

import { useMemo } from 'react'

import { FilterDropdown, FilterDropdownSize, type MenuItem } from '@graftcode/design-system'

import type { GatewayListSelectOption } from '../constants/gatewayListFilters.const'
import { GATEWAY_LIST_FILTER_ALL } from '../constants/gatewayListFilters.const'
import { GATEWAY_LIST_SELECT_FILTER_TEST_IDS } from '../constants/gatewayListFilters.test-ids.const'

type GatewayListSelectFilterProps = {
  value: string
  options: readonly GatewayListSelectOption[]
  disabled?: boolean
  onChange: (value: string) => void
}

export function GatewayListSelectFilter({ value, options, disabled = false, onChange }: GatewayListSelectFilterProps) {
  const selectedLabel = useMemo(
    () => options.find((option) => option.id === value)?.label ?? options[0]?.label ?? '',
    [options, value]
  )

  const menuItems = useMemo<MenuItem[]>(
    () =>
      options.map((option) => ({
        id: option.id,
        label: option.label,
        type: 'item',
        selected: value === option.id,
      })),
    [options, value]
  )

  const isActive = value !== GATEWAY_LIST_FILTER_ALL

  return (
    <div data-testid={GATEWAY_LIST_SELECT_FILTER_TEST_IDS.root}>
      <FilterDropdown
        label={selectedLabel}
        options={menuItems}
        size={FilterDropdownSize.M}
        disabled={disabled}
        active={isActive}
        onClear={isActive ? () => onChange(GATEWAY_LIST_FILTER_ALL) : undefined}
        clearAriaLabel="Clear filter"
        onSelect={onChange}
      />
    </div>
  )
}
